// Utilities
import { useFetchWrapper } from '../helpers';
import { APIS } from '../constants';

const useHelpService = () => {
    const fetchWrapper = useFetchWrapper();

    const postQueries = (payload: any) => {
        return fetchWrapper.post(APIS.HELP.POST_QUERIES, payload);
    }

    const getFAQs = (data: string) =>{
        return fetchWrapper.get(`${APIS.HELP.GET_FAQS}?section=${data}`); 
    }   

    const getProductGuid = () =>{
        return fetchWrapper.get(APIS.HELP.GET_PRODUCT_TOUR);
    }

    return {
        postQueries,
        getFAQs,
        getProductGuid
    }
}

export { useHelpService };